// extracted by mini-css-extract-plugin
export var standaloneTable = "_gu-0";
export var standaloneTableWithBodyFill = "_gu-1";
export var withExtraHeader = "_gu-2";